// extracted by mini-css-extract-plugin
export var badge = "_j0-2";
export var detailsPanel = "_j0-0";
export var resultRow = "_j0-1";